import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { EventManagerPlugin } from '@angular/platform-browser';

@Injectable()
export class GraphEventOptionsPlugin extends EventManagerPlugin {
	constructor() {
		super(inject(DOCUMENT));
	}

	override supports(eventName: string): boolean {
		return eventName === 'wheel' || eventName === 'mousewheel' || eventName === 'touchstart';
	}

	override addEventListener(
		element: HTMLElement,
		eventName: string,
		handler: (event: Event) => void,
		options?: AddEventListenerOptions
	): () => void {
		let listenerOptions = options;
		if (element instanceof Element && options?.passive === undefined) {
			const document = element.ownerDocument;
			const isDocumentRoot = element === document.body || element === document.documentElement;
			if (!isDocumentRoot) {
				// Embedded-view elements may not have their graph ancestor yet. Preserve their
				// default cancellation behavior explicitly; only known graph touchstart is passive.
				listenerOptions = {
					...options,
					passive: eventName === 'touchstart' && element.closest('ngx-graph') !== null
				};
			}
		}
		element.addEventListener(eventName, handler, listenerOptions);
		return () => element.removeEventListener(eventName, handler, listenerOptions);
	}
}
